import { render } from "./wxLayout.vue?vue&type=template&id=6fba1422"
import script from "./wxLayout.vue?vue&type=script&lang=js"
export * from "./wxLayout.vue?vue&type=script&lang=js"

import exportComponent from "E:\\项目\\弗莱德\\DL-Flight.Protal\\DL-Flight.Protal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__